import React from "react";
import { UIRadioSwitch, UICheckbox } from "../../../components/guiElements";

export default function WarehouseOrderOptions({ orderTypes, showOrderTypeSelector, showCustomerPickup, customerPickupLabel, orderType, customerPickup, onOrderTypeChange, onCustomerPickupChange }) {
    return (
        <div className="order-order-config">
            <div className="order-subtitle">
                {orderTypes.title}
            </div>

            <div className="warehouse-order-type-row">
                {showOrderTypeSelector && (
                    <UIRadioSwitch
                        leftLabel={orderTypes.inputs[0]}
                        leftValue={orderTypes.value[0]}
                        rightLabel={orderTypes.inputs[1]}
                        rightValue={orderTypes.value[1]}
                        value={orderType}
                        onChange={onOrderTypeChange}
                    />
                )}

                {showCustomerPickup && (
                    <UICheckbox
                        name="customerPickup"
                        label={customerPickupLabel}
                        value={customerPickup}
                        disabled={
                            orderType !== orderTypes.value[0]
                        }
                        onChange={onCustomerPickupChange}
                    />
                )}
            </div>
        </div>
    );
}